import { render, staticRenderFns } from "./detailbuttons.vue?vue&type=template&id=2974e087"
import script from "./detailbuttons.vue?vue&type=script&lang=js"
export * from "./detailbuttons.vue?vue&type=script&lang=js"
import style0 from "./detailbuttons.vue?vue&type=style&index=0&id=2974e087&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports